import { Button, Card, Typography } from '@sgi/gravity';
import { Form } from 'src/components/forms/components/Form';
import { FormButtonRow } from 'src/components/forms/layout/FormButtonRow';
import { FormLayout } from 'src/components/forms/layout/FormLayout';
import { Country, Provinces } from 'src/types/Location';
import { CustomerAddress } from './components/CustomerAddress';
import { CustomerInfo } from './components/CustomerInfo';
import { CustomerLicenceInfo } from './components/CustomerLicenceInfo/CustomerLicenceInfo';
import { DriverFormValues, DriverFormContext, driverSchema } from './driverSchema';

export type DriverFormProps = {
  onSubmit?: (values: DriverFormValues) => void;
  onCancel?: () => void;
  initialValues?: DriverFormContext;
  isSubmitting?: boolean;
  isEdit: boolean;
};

export const DriverForm = ({ onSubmit, onCancel, initialValues, isSubmitting }: DriverFormProps) => {
  const submitForm = (values: DriverFormValues) => {
    onSubmit?.(values);
  };

  return (
    <Form
      schema={driverSchema}
      onSubmit={submitForm}
      initialValues={{
        customerNumber: initialValues?.customerNumber ?? '',
        driversLicenceNumber: initialValues?.driversLicenceNumber ?? '',
        dateOfBirth: initialValues?.dateOfBirth ?? undefined,
        licenceExpiryDate: initialValues?.licenceExpiryDate ?? undefined,
        driversLicenceClass: initialValues?.driversLicenceClass ?? '',
        driversLicenceJurisdiction: initialValues?.driversLicenceJurisdiction ?? '',
        endorsementsRestrictions: initialValues?.endorsementsRestrictions,
        firstName: initialValues?.firstName ?? '',
        middleName: initialValues?.middleName ?? '',
        lastName: initialValues?.lastName ?? '',
        addressLine1: initialValues?.addressLine1 ?? '',
        addressLine2: initialValues?.addressLine2 ?? '',
        city: initialValues?.city ?? '',
        jurisdiction: initialValues?.jurisdiction ?? Provinces.Saskatchewan,
        country: initialValues?.country ?? Country.Canada,
        postalCode: initialValues?.postalCode ?? '',
      }}
    >
      <FormLayout>
        <Typography variant="h2">Driver Information</Typography>
        <Card>
          <FormLayout>
            <CustomerInfo />
          </FormLayout>
        </Card>
        <Card>
          <FormLayout>
            <CustomerAddress />
          </FormLayout>
        </Card>
        <Card>
          <FormLayout>
            <CustomerLicenceInfo />
          </FormLayout>
        </Card>
        <Card>
          <FormButtonRow>
            <Button type="button" variant="secondary" isDisabled={isSubmitting} onClick={onCancel}>
              Back
            </Button>
            {/*<Button type="submit" variant="primary" isDisabled={isSubmitting} isLoading={isSubmitting} width={'48'}>*/}
            {/*  Submit*/}
            {/*</Button>*/}
          </FormButtonRow>
        </Card>
      </FormLayout>
    </Form>
  );
};
